export const getEvents = async (contract, event) => {
  try {
    const result = await contract.getPastEvents(
      event,
      {
        // filter: filter,
        // filter: {indexedParameter: value}
        fromBlock: 0,
        toBlock: 'latest',
      },
      function (error, events) {
        if (error) {
          console.log(error);
        }
      }
    );
    return result;
  } catch (error) {
    return error;
  }
};

export const getAll = (contract, event, filter) => {
  const events = contract
    .getPastEvents(
      event,
      {
        filter: filter,
        fromBlock: 0,
        toBlock: 'latest',
      },
      function (error, events) {
        if (error) {
          console.log(error);
        }
      }
    )
    .then((events) => {
      
      return events;
    });
    return events;
};

export const positionId = async (
  positionContract,
  poolAddress,
  userAddress
) => {
  const id = await positionContract.methods
    .getNftId(poolAddress, userAddress)
    .call();
  return id;
};
